import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setPrintaction } from "../../../../../redux/printstate/printActions";

function PrintText({ item, title }: any) {
  const dispatch = useDispatch();

  const [cursor, setcursor] = useState("grab");
  const [psi, setpsi] = useState({ x: 0, y: 0 });
  const handleMouseDown = (e: any) => {
    setcursor("grabbing");
    setpsi({
      x: e.offsetY + item?.top,
      y: e.offsetX + item?.left,
    });
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: any) => {
    if (cursor === "grab") {
      dispatch(
        setPrintaction({
          name: item?.title,
          target: "left",
          value: e.offsetX - psi.x,
        })
      );
      dispatch(
        setPrintaction({
          name: item?.title,
          target: "top",
          value: e.offsetY - psi.y,
        })
      );
    }
  };

  const handleMouseUp = () => {
    setcursor("grab");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };
  return (
    <span
      style={{
        fontWeight: 600,
        position: "absolute",
        top: item?.top,
        left: item?.left,

        fontSize: item?.size,
        display: item?.show ? "block" : "none",
        whiteSpace: "nowrap",
        textTransform: "capitalize",
      }}
      className={cursor}
      onMouseDown={handleMouseDown}
    >
      {title}
    </span>
  );
}

export default PrintText;
